import { Head } from '@inertiajs/react'
import PageHeader from './_components/PageHeader'
import OrganizationsList from './_components/OrganizationsList'
import { SalesminerOrganization } from "@/types/serializers";

interface Props {
    organizations: SalesminerOrganization[]
}

export default function Index({organizations}: Props) {
    return (
        <>
            <Head title="Manage Organizations - Super Admin - SalesMinr"/>
            <div className="min-h-screen bg-gray-50">
                <PageHeader title="Manage Organizations"/>

                <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <div className="px-4 py-6 sm:px-0">
                        <OrganizationsList organizations={organizations}/>
                    </div>
                </div>
            </div>
        </>
    )
}